// import Layout from '@/views/layout'

export default [
  // {
  //   path: '/marketCenter',
  //   name: 'marketCenter',
  //   redirect: '/marketCenter/introduce',
  //   component: Layout,
  //   meta: {
  //     title: '营销中心',
  //     icon: 'activity.png',
  //     index: 3
  //   },
  //   children: [
  //     {
  //       path: 'introduce',
  //       name: 'introduce',
  //       meta: {
  //         title: '能＋商城'
  //       },
  //       component: () => import('@/views/marketCenter/introduce')
  //     },
  //     {
  //       path: 'equityPage',
  //       name: 'equityPage',
  //       meta: {
  //         title: '我的权益'
  //       },
  //       component: () => import('@/views/marketCenter/equityPage')
  //     },
  //     {
  //       path: 'equityUseList',
  //       name: 'equityUseList',
  //       hidden: true,
  //       meta: {
  //         title: '权益使用记录'
  //       },
  //       component: () => import('@/views/marketCenter/equityUseList')
  //     },
  //     {
  //       path: 'coupon',
  //       name: 'coupon',
  //       meta: {
  //         title: '商户优惠券列表'
  //       },
  //       component: () => import('@/views/marketCenter/coupon')
  //     },
  //     {
  //       path: 'couponAdd',
  //       name: 'couponAdd',
  //       hidden: true,
  //       meta: {
  //         title: '商户优惠券列表编辑'
  //       },
  //       component: () => import('@/views/marketCenter/couponAdd')
  //     },
  //     {
  //       path: 'marketActivity',
  //       name: 'marketActivity',
  //       meta: {
  //         title: '营销活动列表'
  //       },
  //       component: () => import('@/views/marketCenter/marketActivity')
  //     },
  //     {
  //       path: 'marketActivityDetail',
  //       name: 'marketActivityDetail',
  //       hidden: true,
  //       meta: {
  //         title: '活动效果详情'
  //       },
  //       component: () => import('@/views/marketCenter/marketActivityDetail')
  //     },
  //     {
  //       path: 'callBackAroundDrvier',
  //       name: 'callBackAroundDrvier',
  //       meta: {
  //         title: '召唤周边司机'
  //       },
  //       component: () => import('@/views/marketCenter/callBackAroundDrvier')
  //     },
  //     {
  //       path: 'callBackLoseDrvier',
  //       name: 'callBackLoseDrvier',
  //       meta: {
  //         title: '召回流失司机'
  //       },
  //       component: () => import('@/views/marketCenter/callBackLoseDrvier')
  //     },
  //     {
  //       path: 'myOrder',
  //       name: 'myOrder',
  //       meta: {
  //         title: '我的订单'
  //       },
  //       component: () => import('@/views/marketCenter/myOrder')
  //     },
  //     {
  //       path: 'placeOrder',
  //       name: 'placeOrder',
  //       hidden: true,
  //       meta: {
  //         title: '套餐包下单'
  //       },
  //       component: () => import('@/views/marketCenter/placeOrder')
  //     },
  //     {
  //       path: 'paymentOrder',
  //       name: 'paymentOrder',
  //       hidden: true,
  //       meta: {
  //         title: '订单支付'
  //       },
  //       component: () => import('@/views/marketCenter/paymentOrder')
  //     },
  //     {
  //       path: 'orderCompletion',
  //       name: 'orderCompletion',
  //       hidden: true,
  //       meta: {
  //         title: '订单完成'
  //       },
  //       component: () => import('@/views/marketCenter/orderCompletion')
  //     },
  //     {
  //       path: 'userAgreement',
  //       name: 'userAgreement',
  //       hidden: true,
  //       meta: {
  //         title: '团油用户协议'
  //       },
  //       component: () => import('@/views/marketCenter/userAgreement')
  //     },
  //     {
  //       path: 'shopCoupon',
  //       name: 'shopCoupon',
  //       meta: {
  //         title: '新增店铺券'
  //       },
  //       component: () => import('@/views/marketCenter/shopCouponForm')
  //     },
  //     {
  //       path: 'editShopCoupon',
  //       name: 'editShopCoupon',
  //       hidden: true,
  //       meta: {
  //         title: '编辑店铺券'
  //       },
  //       component: () => import('@/views/marketCenter/shopCouponForm')
  //     },
  //     {
  //       path: 'shopCouponDetail',
  //       name: 'shopCouponDetail',
  //       hidden: true,
  //       meta: {
  //         title: '店铺券详情'
  //       },
  //       component: () => import('@/views/marketCenter/shopCouponDetail')
  //     },
  //     {
  //       path: 'locationSort',
  //       name: 'locationSort',
  //       meta: {
  //         title: '位置排序'
  //       },
  //       component: () => import('@/views/marketCenter/locationSort')
  //     },
  //     {
  //       path: 'locationSortAdd',
  //       name: 'locationSortAdd',
  //       hidden: true,
  //       meta: {
  //         title: '新增排序'
  //       },
  //       component: () => import('@/views/marketCenter/locationSortAdd')
  //     }
  //   ]
  // }
]
